import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { selectActiveCategory, selectActiveTab, selectBanner, selectCategories, selectCategoriesLinks, selectCurrentCategory, selectCurrentFooterLink, selectCurrentNavigation, selectCurrentTab, selectCurrentTabIsActive, selectIsMenuModalOpen, selectIsModalStepSearch, selectNavigationHasTitle, selectRightBlockLinks, selectStoreIcons, selectStoreLinks, selectTabs, withMenuCategoriesMapper, withMenuFooterLinks, withMenuNavigationMapper, withMenuTabMapper } from "../../store/slices/menu/selectors";
import { actionToggleModalMenu, actionToggleSearchStepMenu, setActiveCategory as _setActiveCategory, setActiveTab, toggleModalMenuOpen } from "../../store/slices/menu";
import { Categories } from "./components/Mobile/components/Categories";
import { CategoriesList } from "./components/Mobile/components/Categories/components/CategoriesList";
import { CategoriesItem } from "./components/Mobile/components/Categories/components/CategoriesItem";
import { TabsItem } from "./components/Mobile/components/TabsItem";
import { TabsList } from "./components/Mobile/components/TabsList";
import { NavigationList } from "./components/Mobile/components/NavigationList";
import { NavigationItem } from "./components/Mobile/components/NavigationItem";
import { FooterLinksList } from "./components/Mobile/components/FooterLinksList";
import { FooterLinksItem } from "./components/Mobile/components/FooterLinksItem";
import { StoresBlock } from "./components/Mobile/components/StoresBlock";
import { MobileBanner } from "./components/Mobile/components/MobileBanner";
import { CategoriesLinks } from "./components/Mobile/components/Categories/components/CategoriesLinks";
import { SecondaryBlock } from "./components/Desktop/components/MainNavigationWrapper/components/SecondaryBlock";
import { MainBlock } from "./components/Desktop/components/MainNavigationWrapper/components/MainBlock";
import { NavigationLinksContainer } from "./components/Desktop/components/NavigationLinks";
import { TabWrapper } from "./components/Desktop/components/TabWrapper";
import { ContentWrapper } from "./components/Desktop/components/TabWrapper/components/ContentWrapper";
import { MenuModalLayout } from "./components/MenuModalLayout";
export var CategoriesRC = compose(connect(function (state) {
  return {
    activeCategory: selectActiveCategory(state),
    shouldRender: !!selectActiveCategory(state)
  };
}, function (dispatch) {
  return {
    setActiveCategory: function setActiveCategory(category) {
      return dispatch(_setActiveCategory(category));
    }
  };
}), withRenderFlag)(Categories);
export var MainBlockRC = compose(connect(function (state) {
  return {
    categories: selectCategories(state),
    activeCategory: selectActiveCategory(state)
  };
}, function (dispatch) {
  return {
    onClick: function onClick(category) {
      return dispatch(_setActiveCategory(category));
    }
  };
}))(MainBlock);
export var CategoriesListRC = withMenuCategoriesMapper(CategoriesList);
export var CategoriesItemRC = connect(function (state) {
  return {
    category: selectCurrentCategory(state)
  };
}, function (dispatch) {
  return {
    setActiveCategory: function setActiveCategory(category) {
      return dispatch(_setActiveCategory(category));
    }
  };
})(CategoriesItem);
export var CategoriesLinksRC = compose(connect(function (state) {
  return {
    links: selectCategoriesLinks(state),
    shouldRender: selectCategoriesLinks(state).length
  };
}), withRenderFlag)(CategoriesLinks);
export var SecondaryBlockRC = compose(connect(function (state) {
  return {
    links: selectRightBlockLinks(state),
    shouldRender: selectRightBlockLinks(state).length
  };
}), withRenderFlag)(SecondaryBlock);
export var TabsListRC = compose(connect(function (state) {
  return {
    shouldRender: !!selectTabs(state)
  };
}), withRenderFlag, withMenuTabMapper)(TabsList);
export var TabsItemRC = connect(function (state) {
  return {
    tab: selectCurrentTab(state),
    activeCategory: selectActiveCategory(state),
    isActive: selectCurrentTabIsActive(state)
  };
}, function (dispatch) {
  return {
    onClick: function onClick(tab) {
      return dispatch(setActiveTab(tab));
    }
  };
})(TabsItem);
export var TabWrapperRC = connect(function (state) {
  return {
    activeTab: selectActiveTab(state)
  };
})(TabWrapper);
export var ContentWrapperRC = compose(connect(function (state) {
  return {
    activeTab: selectActiveTab(state)
  };
}))(ContentWrapper);
export var MobileBannerRC = compose(connect(function (state) {
  return {
    banner: selectBanner(state),
    // ToDo: избавиться от подтягивания лишних данных в компонент через обращение к store в headerMetric
    category: selectActiveCategory(state),
    tab: selectActiveTab(state),
    shouldRender: !!selectBanner(state)
  };
}), withRenderFlag)(MobileBanner);
export var NavigationLinksContainerRC = compose(connect(function (state) {
  return {
    tabs: selectTabs(state),
    activeTab: selectActiveTab(state),
    activeCategory: selectActiveCategory(state),
    shouldRender: !!selectTabs(state)
  };
}, function (dispatch) {
  return {
    onHover: function onHover(tab) {
      return dispatch(setActiveTab(tab));
    }
  };
}), withRenderFlag)(NavigationLinksContainer);
export var NavigationListRC = withMenuNavigationMapper(NavigationList);
export var NavigationItemRC = connect(function (state) {
  return {
    navigation: selectCurrentNavigation(state),
    activeTab: selectActiveTab(state),
    activeCategory: selectActiveCategory(state),
    withIndent: selectNavigationHasTitle(state)
  };
})(NavigationItem);
export var FooterLinksListRC = withMenuFooterLinks(FooterLinksList);
export var FooterLinksItemRC = connect(function (state) {
  return {
    link: selectCurrentFooterLink(state)
  };
})(FooterLinksItem);
export var StoresBlockRC = compose(connect(function (state) {
  return {
    storeLinks: selectStoreLinks(state),
    storeIcons: selectStoreIcons(state),
    shouldRender: selectStoreLinks(state) && selectStoreIcons(state)
  };
}), withRenderFlag)(StoresBlock);
export var MenuModalLayoutRC = connect(function (state) {
  return {
    isOpen: selectIsMenuModalOpen(state),
    isSearchStep: selectIsModalStepSearch(state)
  };
}, {
  toggleMenuModal: actionToggleModalMenu,
  toggleStepModalOnSearch: actionToggleSearchStepMenu
})(MenuModalLayout);
export var ShopMenuModalLayoutRC = connect(function (state) {
  return {
    isOpen: selectIsMenuModalOpen(state),
    isSearchStep: true
  };
}, {
  toggleMenuModal: toggleModalMenuOpen
})(MenuModalLayout);